<script>
import { Doughnut } from "vue-chartjs";

export default {
  extends: Doughnut,
  mounted() {
    this.renderChart(
      {
        labels: [
          "SMS",
          "IVR",
          "Operator"
        ],
        datasets: [
          {
            label: "Data 1",
            data: [144, 114, 384],
            backgroundColor: [
              '#28a745',
              '#007bff',
              '#ffc107',
            ],
            hoverOffset: 4,
      
          }
        ]
      },
    );
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/General/Reports/components/Progress.vue